module.exports = __webpack_public_path__ + "img/zhuti-04.9383aaf8.png";